import { WithUserNamespace } from '../../state/user';
import { getLoggedInUser } from './getLoggedInUser';

export const getUserEmail = (state: WithUserNamespace) =>
    getLoggedInUser(state)?.email || '';
